import services from 'services/services';
import * as types from '../types';

// Import helpers
import { checkFetchErrors } from '../helpers_actions/convert_helpers';

// ******************** FETCH SECTION PRODUCTS ********************
export const fetchSectionProducts = (id) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_SECTION_PRODUCTS_LOADING,
			payload: true
		});

		const { data } = await services.get(`/section/${id}/getProducts`);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_SECTION_PRODUCTS_SUCCESS,
			payload: data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_SECTION_PRODUCTS_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
